import styled from "styled-components"

export const Container = styled.div`
  background: #B6E8CC ;
  border-radius: 0.5rem;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 4rem;

  div {
    color: #236647;
    display: flex;
    flex-direction: column;
    line-height: 1.4rem;
    font-size: 1.3rem;

    span {
      font-size: 1.1rem;
    }
  }

  svg {
    height: 2.6rem;
    margin-right: 1.5rem;
    fill: #236647;
  }
`
